import type { ProposalTarget } from "@/services/wingman/mutation-proposal";

/**
 * Soft refresh signal for the editors and lists showing a proposal's target.
 *
 * Approving a proposal in chat changes its target on the server while those pages stay
 * mounted. Emit this once execution settles in a way that shows the target may have changed,
 * never after an approval decision alone, so the pages reconcile in place instead of reloading. The
 * realtime mutation channel may deliver the same change; reconciling twice is harmless, and
 * this signal also covers sessions without that channel.
 */
export const MUTATION_PROPOSAL_APPLIED_EVENT = "gail:mutation-proposal-applied";

export function notifyMutationProposalApplied(target: ProposalTarget): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ProposalTarget>(MUTATION_PROPOSAL_APPLIED_EVENT, { detail: target })
  );
}
